import { render, staticRenderFns } from "./loot.vue?vue&type=template&id=269c62c9"
import script from "./loot.vue?vue&type=script&lang=ts"
export * from "./loot.vue?vue&type=script&lang=ts"
import style0 from "./loot.vue?vue&type=style&index=0&id=269c62c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports